const ProfileIcon = ({
  style = { height: "1.5vh", width: "1.5vh" },
  color = "black",
}) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 36.07 41.46"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m18 17.22a8.61 8.61 0 1 0 -8.58-8.61 8.62 8.62 0 0 0 8.58 8.61zm0-14a5.38 5.38 0 1 1 -5.39 5.38 5.39 5.39 0 0 1 5.39-5.37z"
        fill={color && color}
      />
      <path
        d="m27 19.92h-18a9 9 0 0 0 -9 9v10.92a1.62 1.62 0 0 0 1.62 1.62h32.84a1.62 1.62 0 0 0 1.61-1.62v-10.84a9 9 0 0 0 -9.07-9.08zm5.81 18.31h-4.29v-6.47a1.62 1.62 0 0 0 -3.23 0v6.47h-14.53v-6.47a1.62 1.62 0 0 0 -3.24 0v6.47h-4.29v-9.23a5.82 5.82 0 0 1 5.77-5.85h18a5.81 5.81 0 0 1 5.84 5.85z"
        fill={color && color}
      />
    </svg>
  );
};

export default ProfileIcon;
